import React from 'react';
import { Modal } from '@brighterion/br-ui';
import DeployModalContent from './DeployModalContent';

interface DeployModalProps {
    isOpen: boolean;
    closeModal(): void;
    rulesType?: RulesType;
}

const DeployModal = ({ isOpen, closeModal, rulesType }: DeployModalProps) => {
    return (
        <Modal
            isOpen={isOpen}
            dataTestId='deploy-modal'
            closeModal={() => closeModal()}
            status='warning'
            closeOnClickOutside={false}
        >
            <DeployModalContent closeModal={closeModal} rulesType={rulesType} />
        </Modal>
    );
};

export default DeployModal;
